import { Reveal } from "./Reveal";
import { TESTIMONIALS, IMAGES } from "./data";
import { Quote, Star } from "lucide-react";

export const Testimonials = () => (
  <section id="reviews" aria-labelledby="reviews-heading" data-testid="testimonials-carousel" className="py-16 md:py-24 bg-brand-cream">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="max-w-2xl mb-12">
          <span className="text-sm font-bold uppercase tracking-wide text-brand-accentink">Kind words</span>
          <h2 id="reviews-heading" className="mt-3 font-heading font-extrabold tracking-tight text-3xl md:text-4xl text-brand-blue">Loved by families & businesses</h2>
        </div>
      </Reveal>
      <div className="grid md:grid-cols-12 gap-6">
        <Reveal className="md:col-span-4">
          <div className="relative h-full min-h-[18rem] rounded-3xl overflow-hidden shadow-[0_12px_36px_rgba(2,71,157,0.1)]">
            <img src={IMAGES.team} alt="The friendly Aid in Clean crew with their eco-friendly cleaning supplies" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-blue/70 to-transparent" />
            <p className="absolute bottom-6 left-6 right-6 text-white font-heading font-bold text-xl">The team you'll come to trust.</p>
          </div>
        </Reveal>
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={0.06 * i} className={i === 0 ? "md:col-span-8" : "md:col-span-4"}>
            <figure className="h-full rounded-3xl bg-white border border-brand-line p-8 flex flex-col justify-between shadow-[0_12px_36px_rgba(2,71,157,0.06)]">
              <div>
                <div className="flex gap-1 text-brand-green" aria-label="5 out of 5 stars">
                  {[...Array(5)].map((_, k) => (<Star key={k} className="h-4 w-4 fill-brand-green" aria-hidden="true" />))}
                </div>
                <Quote className="mt-4 h-8 w-8 text-brand-blue/20" aria-hidden="true" />
                <blockquote className="mt-3 font-heading font-semibold text-lg md:text-xl leading-snug text-brand-ink">“{t.quote}”</blockquote>
              </div>
              <figcaption className="mt-8 pt-6 border-t border-brand-line">
                <span className="block font-bold text-brand-ink">{t.name}</span>
                <span className="block text-sm text-brand-ink2">{t.role}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
